import React, { useRef, useEffect, useState } from 'react';
import { paymentWebsiteOrigin } from 'utils';
import { createStyles } from 'utils/createStyle';

export const PaymentIframe = ({ src }: { src: string }) => {
    const [iframeHeight, setIframeHeight] = useState('300px');
    const iframeRef = useRef(null);

    useEffect(() => {
        const handleMessage = (event: any) => {
            // Validate that the message comes from the expected iframe domain
            if (event.origin !== paymentWebsiteOrigin()) {
                return;
            }

            if (event.data.type === 'setHeight' && event.data.height) {
                setIframeHeight(`${event.data.height}px`);
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <iframe
            ref={iframeRef}
            id="payment-iframe"
            src={src}
            title="Cross Domain Iframe"
            className="w-full border-none"
            style={{ height: iframeHeight }}
        />
    );
};
